// 增加臨時pt翻譯

const tempTranslateList = [{
        normal: '舉辦“大健康產業的發展優勢與挑戰”及“元宇宙未來發展與應用趨勢”兩場論壇。',
        pt: 'Realizam-se dois fóruns de tópicos “As Vantagens e os Desafios no Desenvolvimento da Indústria de Grande Saúde” e “O  Futuro Desenvolvimento do Metaverso e as Tendências da Sua Aplicação ”.'
    },
    {
        normal: '展示本澳及周邊地區科創企業的創新成果，締造交流合作的機會。',
        pt: 'Demonstram-se resultados inovadores das empresas de inovação tecnológica de Macau e das regiões vizinhas e criam-se oportunidades de intercâmbio e cooperação.'
    },
    {
        normal: '以互動方式展示內地不同地區的最新科技和科研成果，增強對內地最新科技發展的了解。',
        pt: 'Exibem-se, de forma interactiva, novas realizações de várias regiões do Interior da China em ciência e tecnologia e em investigação científica, reforçando o conhecimento sobre o recente desenvolvimento de ciência e tecnologia.',
    },
    {
        normal: '展示本年度“科研成果宣傳推廣活動”的成果，由青少年以創新的宣傳方式，推廣本澳高水平科研成果，鼓勵更多青少年投入參與科技創新。',
        pt: 'Exibem-se os resultados da “Actividade de Promoção e Divulgação dos Resultados de Investigação Científica” neste ano, sendo divulgados pelos jovens, de forma inovadora, os resultados de investigação científica de alto nível de Macau, para encorajar mais jovens a dedicarem-se e participarem na inovação científica e tecnológica.'
    },
    {
        normal: '展示獲科技基金資助的科研成果，提供與科技企業及資本進行對接的機會，助力具條件的成果實現轉移轉化。',
        pt: 'Apresentam-se resultados de investigação científica financiados pelo Fundo para o Desenvolvimento das Ciências e da Tecnologia, e disponibilizam-se possibilidades de contacto com empresas de ciência e tecnologia e fundos, ajudando a realização de transferência e transformação dos resultados com condições.'
    }
]
export const tempTranslation = (str = null) => {
    if (!str) return false
    const res = tempTranslateList.filter(item => item.normal === str)
    if (res.length !== 0) {
        return res[0].pt
    }
    return false

}